/**
 * Estrutura previsivel enquanto a PRIMEIRA consulta carrega (contrato `Skeleton` do catalogo).
 *
 * PROMOVIVEL: sao blocos, nao texto falso - a regra do catalogo e "imita blocos, nao texto falso
 * detalhado". O que este componente promete e a FORMA do que vem, para a pagina nao saltar quando
 * o conteudo chegar.
 *
 * Nao usar em atualizacao de conteudo ja visivel: ai a regra e o contrario ("loading nunca apaga
 * conteudo estavel"), e quem serve e o `Spinner` sobre o conteudo que fica.
 *
 * TERCEIRA COPIA (NIG, Report Viewer, e aqui). A regra escrita nas duas anteriores era subir para
 * `@ledger-glass/react` nesta hora; a decisao de 2026-09-29 foi copiar mais uma vez e promover
 * depois (spec 0008, "Promocao ao pacote"), para entregar o manager sem mexer no repositorio do
 * design system nem em producao.
 *
 * Isto e DIVIDA REGISTRADA, nao regra abandonada: a partir daqui sao tres implementacoes da mesma
 * peca evoluindo em paralelo. Quem for promover, compare as tres primeiro - hoje sao identicas por
 * construcao, e o que tiver divergido dira o que cada app precisou.
 */

export function Skeleton({ height, width = '100%' }: { height: number | string; width?: number | string }) {
  return <span className="skeleton" style={{ height, width }} aria-hidden="true" />
}
